
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-member/[uid]",
      function () {
        return require("private-next-pages/team-member/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-member/[uid]"])
      });
    }
  